import 'mocha!./tests'



// WEBPACK FOOTER //
// ./test/web-test.js